module.exports = __webpack_public_path__ + "img/hourglass.32476ec6.svg";